import {
  HydratedAsset,
  isAgentAsset,
  isCanvasAsset,
  isChatbotAsset,
  isInterfaceAsset,
  isTableAsset,
  isZapAsset,
} from "@zapier/client";

/**
 * Whether this build has a dedicated row, and therefore routable bulk actions,
 * for the asset's type.
 */
export function hasRecognizedAssetType(asset: HydratedAsset) {
  return (
    isTableAsset(asset) ||
    isInterfaceAsset(asset) ||
    isCanvasAsset(asset) ||
    isChatbotAsset(asset) ||
    isAgentAsset(asset) ||
    isZapAsset(asset)
  );
}
